document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.m6060-product');
  if (!section) return;
  const colors = section.querySelector('[data-color-group]');
  const gallery = section.querySelector('[data-product-gallery]');
  if (!colors || !gallery) return;
  const update = () => {
    const color = colors.querySelector('[data-option-value]:checked')?.value || 'Cream';
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.hidden = thumb.dataset.galleryColor !== 'Shared' && thumb.dataset.galleryColor !== color;
      const active = !thumb.hidden && main?.src === thumb.dataset.src;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', String(active));
    });
    const selected = colors.querySelector('[data-selected-color]');
    if (selected) selected.textContent = color;
  };
  section.querySelector('[data-variant-picker]')?.addEventListener('change', update);
  window.addEventListener('popstate', update);
  window.addEventListener('pageshow', update);
  document.querySelectorAll('[data-fleece-select-color]').forEach(button => {
    button.addEventListener('click', () => {
      const input = [...colors.querySelectorAll('[data-option-value]')].find(item => item.value === button.dataset.fleeceSelectColor);
      if (!input || input.disabled) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      input.focus({ preventScroll: true });
    });
  });
  update();
});
